__turbopack_context__.v({
  "cats": "style-module-scss-module__cX9AXG__cats",
  "item": "style-module-scss-module__cX9AXG__item",
  "label": "style-module-scss-module__cX9AXG__label",
  "title": "style-module-scss-module__cX9AXG__title",
});
